<script>
import vmware_requestService from '@/api-services/vmware_request.service'
import apiutil from '@/util/apiutil'
import {BAlert} from 'bootstrap-vue'

export default {
  name: 'FQDNSelection',
  components: { BAlert },
  props: {
    value: { type: String, default: null },
    field_enumeration_index: { type: Number, required: true },
  },
  data() {
    return { validation_result: {} }
  },
  computed: {
    rules() {
      const r = this.validation_result
      if (!r.exists) return [] // noch nicht validiert
      return [
        { satisfied: r.exists.valid, key: 'no_fqdn_selected' },
        { satisfied: r.aaaa_record.valid, key: 'no_ipv6_records' },
        { satisfied: r.all_records_singleton.valid, key: 'target_is_singleton' },
        { satisfied: r.all_records_reverse_unique.valid, key: 'target_is_reverse_unique' },
        { satisfied: r.same_bcd.valid, key: 'ipv4_and_ipv6_bcds_not_same' },
        { satisfied: r.vlan.valid, key: 'not_local_dc' },
      ]
    },
    is_valid() {
      if (this.rules.length === 0) return null // noch nicht geprüft
      return this.rules.every(rule => rule.satisfied)
    },
    error() {
      const violation = this.rules.find(rule => !rule.satisfied)
      return violation
        ? this.$t(`components.requests.vmware.fqdn.validation.${violation.key}`)
        : null
    },
  },
  watch: {
    is_valid: {
      immediate: true,
      handler(v) { this.$emit('validity-change', v === true) },
    },
    value(v) {
      if (!v) this.validation_result = {}
    },
  },
  methods: {
    on_input(val) {
      this.validation_result = {} // altes Ergebnis ist ungültig
      this.$emit('input', val)
    },
    async validate() {
      console.log(this.value)
      const fqdn = this.value
      if (!fqdn) return
      console.log('!fqdn was true')
      const { data } = await vmware_requestService.validate_fqdn(this.$store.state, fqdn)
      if (fqdn !== this.value) return // veraltete Antwort verwerfen
      console.log('veraltete antwort nicht verworfen')
      this.validation_result = apiutil.dict_by_value_of_array(data.validation_rules, 'rule_name')
    },
  },
}
</script>

<template>
  <div>
    <b-form-group
      :label="$t(`global.enumeration.${field_enumeration_index}`, { msg: $t('components.requests.vmware.fqdn.label') })"
      :description="$t('components.requests.vmware.fqdn.description')"
      label-for="fqdn-name-vm">
      <b-input id="fqdn-name-vm"
               :value="value"
               :placeholder="$t('components.requests.vmware.fqdn.placeholder')"
               :state="is_valid"
               @input="on_input"
               @blur="validate($event)" />
      <b-form-invalid-feedback :state="false">{{ error }}</b-form-invalid-feedback>
    </b-form-group>
    <b-alert variant="info" show>
      <b-row>
        <b-col cols="auto" class="my-auto">
          <netvs-icon icon="info" size="2x"></netvs-icon>
        </b-col>
        <b-col class="h-100 my-auto">
          <ul class="my-auto">
            <li>{{ $t('components.requests.vmware.fqdn_requirements.aaaa_rr') }}</li>
            <li>{{ $t('components.requests.vmware.fqdn_requirements.rr_same_bcd') }}</li>
            <li>{{ $t('components.requests.vmware.fqdn_requirements.bcd_rr') }}</li>
          </ul>
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>
